import React from 'react'
import LatinoTemplateDefault from 'src/components/template/la/'

export default (props) => {
  return (
    <LatinoTemplateDefault
      location={props.location}
      lang="es"
      market="latino"
      title={
        <>
          Mira LaLiga <span className="desktop-line-break">en vivo </span>{' '}
        </>
      }
      pageTitle="Mira LaLiga en vivo"
      tagline={
        <>
          Sigue los partidos en ESPN Deportes
          <span className="desktop-line-break"> desde cualquier dispositivo con Fubo</span>
        </>
      }
      networkSet="entertainmentLatino"
      noteLink="/la/la-liga-on-espn-deportes/"
      poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/LaLiga_Ver1_Web.jpg"
      posterMobile="https://assets-imgx.fubo.tv/marketing/lp/images/posters/LaLiga_Ver1_Mobile.jpg"
    />
  )
}
